class Client {
    id = null;
    name = '';
    oib = '';
    hash = '';
    valid_until = null;
    api_token = '';
    plus = false;
    discount = 0;
    official_email = '';
    regiondo_data = '';
    financial_status_id = 1;
    invoices = [];
    ais_api_key = null;
    ais_account_id = null;
    selected_invoice_hashes = null;
    ignored_invoice_hashes = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Client;